import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment StatsSplitWithImageData on StrapiComponentStatsSplitWithImage {
    title
    topic
    description
    image {
      ...StrapiMediaSubquery
    }
    icon {
      ...StrapiMediaSubquery
    }
    items {
      label
      value
    }
  }
`;

function SplitWithImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="relative bg-background-white">
      <div className="h-56 bg-background-primary sm:h-72 lg:absolute lg:left-0 lg:h-full lg:w-1/2">
        {data.image && (
          <MediaWrapper media={data.image} divClassName="w-full h-full" />
        )}
      </div>
      <div className="relative mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:py-16">
        <div className="mx-auto max-w-2xl lg:ml-auto lg:mr-0 lg:w-1/2 lg:max-w-none lg:pl-10">
          <div>
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-background-primary text-text-white">
              {data.icon && (
                <MediaWrapper
                  media={data.icon}
                  objectFit="contain"
                  divClassName="h-6 w-6"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
          {data.topic && (
            <h3 className="block text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="mt-6 text-3xl font-extrabold text-text-primary sm:text-4xl">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              replaceParagraph={false}
              markdownClassName="mt-6 text-lg text-text-secondary"
            />
          )}
          <div className="mt-8 overflow-hidden">
            {Boolean(data.items?.length) && (
              <dl className="-mx-8 -mt-8 flex flex-wrap">
                {data.items.slice(0, 4).map((item) => (
                  <div className="flex flex-col px-8 pt-8" key={item.title}>
                    <dt className="order-2 text-base font-medium text-text-secondary">
                      <MarkdownWrapper
                        text={item.label}
                        replaceParagraph={false}
                      />
                    </dt>
                    <dd className="order-1 text-2xl font-extrabold text-text-primary sm:text-3xl">
                      <MarkdownWrapper
                        text={item.value}
                        replaceParagraph={false}
                      />
                    </dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

SplitWithImage.propTypes = {
  data: PropTypes.object,
};

export default SplitWithImage;
